const publicDomain = 'http://127.0.0.1';
const privateDomain = `http://127.0.0.1`;
const appHost = `http://127.0.0.1`;
const appConfig = {
  version: "2020.1",
  name: "SATIS",
  appFullName: (plan) => `SATIS ${plan} 2020.1`,
  enterprise: "DMD",
  contact: "21256325",
  timeAfterDisconnection: 8,
  apiDomaine:`https://macro-update-backend-demo.satisworld.online`,
  host: `macro-update-backend-demo.satisworld.online`,
  port: 80,
  language: "fr",
  useManyLanguage: "false",
  listConnectData: {
    PRO: {
      grant_type: "grant_type",
      client_id: 2,
      client_secret: "eL0VZVijea20dcvKU5l5wVxXu6EGtDIda5TkXY8H",
      username: "username",
      password: "password",
    },
    HUB: {
      grant_type: "grant_type",
      client_id: 2,
      client_secret: "eL0VZVijea20dcvKU5l5wVxXu6EGtDIda5TkXY8H",
      username: "username",
      password: "password",
    },
    MACRO: {
      grant_type: "password",
      client_id: 4,
      client_secret: "QGxBDdQe85xCqTymiD2rQQ6KdDeKXW3nCpjv0jUQ",
      username: "username",
      password: "password",
    },
  },
};
export default appConfig;
